// extracted by mini-css-extract-plugin
module.exports = {"theme":"#82ad44"};